module.exports = __webpack_public_path__ + "img/voice of an echo.7ffd8398.png";